<template>
    <div>
        <div v-if="form" @keydown="change">
            <form-title>Company</form-title>
            <input-text v-model="form.team_name" field="team_name" :form="form" label="Company Name" />
            <input-text
                v-model="form.owner_details.business_name"
                field="owner_details.business_name"
                :form="form"
                label="Legal Business Name"
                subLabelText="* Optional"
                :labelProps="{ class: 'd-flex flex-row-reverse justify-content-between align-items-baseline' }"
            />
            <div style="margin-bottom: 1rem">
                <label class="mr-3 mb-2">Agency</label>
                <select class="form-control" name="agency_id" v-model="form.agency_id">
                    <option :key="0" :value="null" selected>-</option>
                    <option v-for="agency in agencies" :key="agency.id" :value="agency.id">
                        {{ agency.name }}
                    </option>
                </select>
            </div>
            <input-text
                type="number"
                v-model="form.trial_days"
                field="trial_days"
                :form="form"
                label="Trial Days"
                placeholder="Default 30 days"
            />
            <input-text label="External CRM Team ID" v-model="form.external_crm_id" />
            <form-title>Owner Details</form-title>
            <div v-if="form.owner_details" class="form-group d-flex align-items-center mt-2">
                <label class="mr-3 mb-0"> Independent Business </label>
                <toggle-button
                    class="changed-font mb-0"
                    v-model="form.owner_details.independent_business"
                    sync
                    :color="{ checked: '#0074d9', unchecked: '#dc3545' }"
                    :labels="{ checked: 'Yes', unchecked: 'No' }"
                    :width="85"
                    :speed="200"
                />
            </div>
            <div
                v-if="
                    !this.systemConfig.kioskOwnerDetailsDisabled ||
                    !!form.agency_id ||
                    (form.owner_details && !form.owner_details.independent_business)
                "
            >
                <div class="form-group d-flex align-items-center">
                    <label class="mr-3 mb-0">Company US Based</label>
                    <toggle-button
                        class="changed-font mb-0"
                        v-model="form.owner_details.is_us_based"
                        :color="{ checked: '#0074d9', unchecked: '#dc3545' }"
                        :labels="{ checked: 'Yes', unchecked: 'No' }"
                        :width="85"
                        :speed="200"
                    />
                </div>
                <div class="form-group d-flex align-items-center">
                    <label class="mr-3 mb-0">Uses Standard Profile (6 or more locations)</label>
                    <toggle-button
                        class="changed-font mb-0"
                        v-model="form.owner_details.uses_standard_profile"
                        :color="{ checked: '#0074d9', unchecked: '#dc3545' }"
                        :labels="{ checked: 'Yes', unchecked: 'No' }"
                        :width="85"
                        :speed="200"
                    />
                </div>
                <div v-if="form.owner_details" class="form-group d-flex align-items-center mt-2">
                    <label class="mr-3 mb-0"> Submit twilio registration </label>
                    <toggle-button
                        class="changed-font mb-0"
                        v-model="form.submit_to_twilio"
                        sync
                        :color="{ checked: '#0074d9', unchecked: '#dc3545' }"
                        :labels="{ checked: 'Yes', unchecked: 'No' }"
                        :width="85"
                        :speed="200"
                    />
                </div>
                <div class="form-row">
                    <div class="col-6">
                        <input-text
                            v-model="form.owner_details.first_name"
                            field="owner_details.first_name"
                            :form="form"
                            label="First Name"
                        />
                    </div>
                    <div class="col-6">
                        <input-text v-model="form.owner_details.last_name" field="owner_details.last_name" :form="form" label="Last Name" />
                    </div>
                </div>
                <input-text v-model="form.owner_details.address" field="owner_details.address" :form="form" label="Address" />
                <input-text v-model="form.owner_details.address2" field="owner_details.address2" :form="form" label="Address Line 2" />
                <input-text v-model="form.owner_details.city" field="owner_details.city" :form="form" label="City" />
                <div class="form-row">
                    <div class="col-6" v-show="form.owner_details.is_us_based">
                        <label class="mr-3 mb-2">State</label>
                        <select class="form-control" name="owner_details.state" v-model="form.owner_details.state">
                            <option v-for="state in states" :key="state.abbreviation + state.name" :value="state.abbreviation">
                                {{ state.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-6" v-show="!form.owner_details.is_us_based">
                        <input-text v-model="form.owner_details.state" field="owner_details.state" :form="form" label="State" />
                    </div>
                    <div class="col-6">
                        <input-text v-model="form.owner_details.zip" field="owner_details.zip" :form="form" label="Postal Code" />
                    </div>
                </div>
                <input-text
                    v-model="form.owner_details.country"
                    field="owner_details.country"
                    :form="form"
                    label="Country"
                    v-show="!form.owner_details.is_us_based"
                />
                <input-text v-model="form.owner_details.email" field="owner_details.email" :form="form" label="Company Email" />
                <input-text
                    v-model="form.owner_details.phone"
                    field="owner_details.phone"
                    :form="form"
                    label="Company Phone (with country code)"
                    placeholder="+1(XXX)XXX-XXXX"
                />
                <div class="form-row form-group">
                    <div class="col-12">
                        <label class="mr-3 mb-2">Business Type</label>
                        <select class="form-control" name="owner_detail_business_type" v-model="form.owner_details.business_type">
                            <option v-for="bt in businessTypes" :key="bt.id" :value="bt.id">
                                {{ bt.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="form-row form-group">
                    <div class="col-12">
                        <label class="mr-3 mb-2">Industry</label>
                        <select class="form-control" name="owner_detail_business_type" v-model="form.owner_details.business_industry">
                            <option v-for="industry in industries" :key="industry.id" :value="industry.id">
                                {{ industry.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div v-if="form.owner_details.independent_business">
                    <div class="form-row form-group">
                        <div class="col-12">
                            <label class="mr-3 mb-2">Registration Identifier Type</label>
                            <select
                                class="form-control"
                                name="owner_detail_business_type"
                                v-model="form.owner_details.business_registration_identifier"
                            >
                                <option v-for="regId in registrationIdentifiers" :key="regId.id" :value="regId.id">
                                    {{ regId.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <input-text
                        v-model="form.owner_details.business_registration_number"
                        field="owner_details.business_registration_number"
                        :form="form"
                        label="Business Identifier (EIN or DUNS number)"
                    />
                    <div class="form-row form-group">
                        <div class="col-12">
                            <label class="mr-3 mb-2">Company Type</label>
                            <select class="form-control" name="owner_detail_business_type" v-model="form.owner_details.company_type">
                                <option v-for="type in companyTypes" :key="type.id" :value="type.id">
                                    {{ type.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div v-show="form.owner_details.company_type == 'public'">
                        <div class="form-row form-group">
                            <div class="col-12">
                                <label class="mr-3 mb-2">Stock Exchange</label>
                                <select class="form-control" name="owner_detail_business_type" v-model="form.owner_details.stock_exchange">
                                    <option v-for="exchange in stockExchanges" :key="exchange.id" :value="exchange.id">
                                        {{ exchange.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <input-text
                            v-model="form.owner_details.stock_ticker"
                            field="owner_details.stock_ticker"
                            :form="form"
                            label="Stock Ticker"
                        />
                    </div>
                </div>
                <div v-else>
                    <label>Parent Company</label>
                    <div class="form-row">
                        <div class="col-9">
                            <input-text class="col-lg-12 pl-0" v-model="searchEIN" placeholder="Search Company EIN" />
                        </div>
                        <div class="col-3">
                            <button-loading
                                class="btn btn-primary"
                                @click="searchParentCompanyByBusinessIdentifier"
                                :loading="searchingEIN"
                                :disabled="searchingEIN"
                            >
                                Search
                            </button-loading>
                        </div>
                    </div>
                    <div class="text-danger" v-if="form.errors.has('owner_details.parent_team.id')">
                        <small>Business Registration Number is required.</small>
                    </div>
                    <div v-if="!!parentTeamOwnerDetailsResponse">
                        <div v-if="parentTeamOwnerDetailsResponse.name">
                            <table class="table">
                                <thead>
                                    <th scope="col" style="width: 33%"></th>
                                    <th scope="col" style="width: 99%">Team Name</th>
                                </thead>
                                <tbody>
                                    <tr scope="row">
                                        <td>
                                            <button class="btn btn-primary" @click="updateParentCompany">Use</button>
                                        </td>
                                        <td>
                                            {{ parentTeamOwnerDetailsResponse.name }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="h4 text-danger text-center" v-if="parentTeamOwnerDetailsResponse.error">
                            {{ parentTeamOwnerDetailsResponse.error }}
                        </div>
                    </div>
                    <div v-if="form.owner_details.parent_team.id">
                        <input-text
                            v-model="form.owner_details.parent_team.name"
                            field="owner_details.parent_team.name"
                            :form="form"
                            label="Parent Company Name"
                            :subLabelProps="{ class: 'text-danger' }"
                            disabled="disabled"
                        />
                        <input-text
                            v-model="form.owner_details.business_registration_identifier"
                            field="owner_details.business_registration_identifier"
                            :form="form"
                            :subLabelProps="{ class: 'text-danger' }"
                            label="Business Registration Identifier"
                            disabled="disabled"
                        />
                        <input-text
                            v-model="form.owner_details.business_registration_number"
                            field="owner_details.business_registration_number"
                            :form="form"
                            :subLabelProps="{ class: 'text-danger' }"
                            label="Business Registration Number"
                            disabled="disabled"
                        />
                    </div>
                </div>
                <input-text v-model="form.owner_details.website_url" field="owner_details.website_url" :form="form" label="Website URL" />
                <input-text
                    v-model="form.owner_details.social_media_profile_urls"
                    field="owner_details.social_media_profile_urls"
                    :form="form"
                    label="Social Media Profile Url's (comma separated)"
                />
            </div>
            <form-title>Primary User</form-title>
            <input-text v-model="form.name" field="name" :form="form" label="Name" />
            <input-text v-model="form.email" field="email" :form="form" label="Email Address" />
            <input-text v-model="form.password" field="password" :form="form" type="password" label="Password" />
            <input-text
                v-model="form.password_confirmation"
                field="password_confirmation"
                :form="form"
                type="password"
                label="Confirm Password"
            />
            <international-twilio-phone
                :register_form="form"
                label="Country code/Area code"
                v-if="
                    !this.systemConfig.kioskOwnerDetailsDisabled ||
                    !!form.agency_id ||
                    (form.owner_details && !form.owner_details.independent_business)
                "
            />
            <form-title>Features</form-title>
            <div class="form-group d-flex align-items-center">
                <label class="mr-3 mb-0">Messenger</label>
                <toggle-button
                    class="changed-font mb-0"
                    v-model="form.messenger"
                    :color="{ checked: '#0074d9', unchecked: '#dc3545' }"
                    :labels="{ checked: 'Active', unchecked: 'Inactive' }"
                    :width="85"
                    :speed="200"
                    :sync="form.messenger"
                />
            </div>

            <div class="form-group d-flex align-items-center">
                <label class="mr-3 mb-0">Appointment Request</label>
                <toggle-button
                    class="changed-font mb-0"
                    v-model="form.appointment"
                    :color="{ checked: '#0074d9', unchecked: '#dc3545' }"
                    :labels="{ checked: 'Active', unchecked: 'Inactive' }"
                    :width="85"
                    :speed="200"
                    :sync="form.appointment"
                />
            </div>

            <div class="form-group d-flex align-items-center">
                <label class="mr-3 mb-0">Google Review API</label>
                <toggle-button
                    class="changed-font mb-0"
                    v-model="form.google_api_enabled"
                    :color="{ checked: '#0074d9', unchecked: '#dc3545' }"
                    :labels="{ checked: 'Active', unchecked: 'Inactive' }"
                    :width="85"
                    :speed="200"
                    :sync="form.google_api_enabled"
                />
            </div>

            <div class="form-group d-flex align-items-center">
                <label class="mr-3 mb-0">WebChat</label>
                <toggle-button
                    class="changed-font mb-0"
                    v-model="form.web_chat"
                    :color="{ checked: '#0074d9', unchecked: '#dc3545' }"
                    :labels="{ checked: 'Active', unchecked: 'Inactive' }"
                    :width="85"
                    :speed="200"
                    :sync="form.web_chat"
                />
            </div>

            <div class="form-group d-flex align-items-center">
                <label class="mr-3 mb-0">Schedule</label>
                <toggle-button
                    class="changed-font mb-0"
                    v-model="form.schedule"
                    :color="{ checked: '#0074d9', unchecked: '#dc3545' }"
                    :labels="{ checked: 'Active', unchecked: 'Inactive' }"
                    :width="85"
                    :speed="200"
                    :sync="form.schedule"
                />
            </div>

            <div class="form-group d-flex align-items-center">
                <label class="mr-3 mb-0">Providers</label>
                <toggle-button
                    class="changed-font mb-0"
                    v-model="form.providers_enabled"
                    :color="{ checked: '#0074d9', unchecked: '#dc3545' }"
                    :labels="{ checked: 'Active', unchecked: 'Inactive' }"
                    :width="85"
                    :speed="200"
                    :sync="form.providers_enabled"
                />
            </div>

            <div class="form-group d-flex align-items-center">
                <label class="mr-3 mb-0">New Experience</label>
                <toggle-button
                    class="changed-font mb-0"
                    v-model="form.version_three_enabled"
                    :color="{ checked: '#0074d9', unchecked: '#dc3545' }"
                    :labels="{ checked: 'Active', unchecked: 'Inactive' }"
                    :width="85"
                    :speed="200"
                    sync
                />
            </div>

            <div class="form-group d-flex align-items-center">
                <label class="mr-3 mb-0">Single Contact Per Location</label>
                <toggle-button
                    class="changed-font mb-0"
                    v-model="form.single_contact_per_location"
                    :color="{ checked: '#0074d9', unchecked: '#dc3545' }"
                    :labels="{ checked: 'Active', unchecked: 'Inactive' }"
                    :width="85"
                    :speed="200"
                    :sync="form.single_contact_per_location"
                    @change="enableLocationPhoneNumbers"
                />
            </div>

            <div class="form-group d-flex align-items-center">
                <label class="mr-3 mb-0">Unread Messages By User</label>
                <toggle-button
                    class="changed-font mb-0"
                    v-model="form.messenger_unread_messages_by_user"
                    :color="{ checked: '#0074d9', unchecked: '#dc3545' }"
                    :labels="{ checked: 'Active', unchecked: 'Inactive' }"
                    :width="85"
                    :speed="200"
                    :sync="form.messenger_unread_messages_by_user"
                />
            </div>
            <div class="form-group d-flex align-items-center">
                <label class="mr-3 mb-0">Location Phone Number</label>
                <toggle-button
                    class="changed-font mb-0"
                    v-model="form.location_phone_numbers_enabled"
                    :color="{ checked: '#0074d9', unchecked: '#dc3545' }"
                    :labels="{ checked: 'Active', unchecked: 'Inactive' }"
                    :width="85"
                    :speed="200"
                    :sync="true"
                    @change="disableSingleContactPerLocation"
                />
            </div>
            <div class="form-group d-flex align-items-center">
                <label class="mr-3 mb-0">Patient Experience</label>
                <toggle-button
                    class="changed-font mb-0"
                    v-model="form.patient_experience"
                    :color="{ checked: '#0074d9', unchecked: '#dc3545' }"
                    :labels="{ checked: 'Active', unchecked: 'Inactive' }"
                    :width="85"
                    :speed="200"
                    :sync="form.patient_experience"
                />
            </div>
            <div class="form-group d-flex align-items-center">
                <label class="mr-3 mb-0">General Survey</label>
                <toggle-button
                    class="changed-font mb-0"
                    v-model="form.general_survey"
                    :color="{ checked: '#0074d9', unchecked: '#dc3545' }"
                    :labels="{ checked: 'Active', unchecked: 'Inactive' }"
                    :width="85"
                    :speed="200"
                    :sync="form.general_survey"
                />
            </div>
            <div class="form-group d-flex align-items-center">
                <label class="mr-3 mb-0">Throttle Messaging</label>
                <toggle-button
                    class="changed-font mb-0"
                    v-model="form.throttle_messaging"
                    :color="{ checked: '#0074d9', unchecked: '#dc3545' }"
                    :labels="{ checked: 'Active', unchecked: 'Inactive' }"
                    :width="85"
                    :speed="200"
                    :sync="form.throttle_messaging"
                />
            </div>
            <div class="row" v-if="countryCodes.length > 0">
                <div class="col-lg-12">
                    <div class="form-group">
                        <label>Default Country Code</label>
                        <select class="form-control" v-model="form.country_code_id">
                            <option :value="null"></option>
                            <option v-for="countryCode in countryCodes" :key="countryCode.id" :value="countryCode.id">
                                {{ countryCode.short_name }} {{ countryCode.code }} - {{ countryCode.long_name }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-12">
                    <div class="form-group">
                        <label>Timezone</label>
                        <small v-if="!form.timezone" class="ml-auto float-right text-muted" style="padding-top: 4px">
                            Server Time:
                            <server-time class="ml-1" format="hh:mm:ss a" />
                        </small>
                        <small v-else class="ml-auto float-right text-muted" style="padding-top: 4px">
                            Your Time:
                            <server-time class="ml-1" format="hh:mm:ss a" :timezone="form.timezone" />
                        </small>
                        <select class="form-control" v-model="form.timezone" :class="form.errors.has('timezone') ? 'is-invalid' : ''">
                            <option :value="null"></option>
                            <option v-for="timezone in timezones" :key="timezone.value" :value="timezone.value">
                                {{ timezone.name }}
                            </option>
                        </select>
                        <p class="invalid-feedback" v-if="form.errors.has('timezone')">{{ form.errors.get("timezone") }}</p>
                    </div>
                </div>
            </div>
            <form-title>Onboarding Features</form-title>
            <div v-if="form.onboardingOptions">
                <div class="form-group d-flex align-items-center" @click="initGoogleSetup">
                    <label class="mr-3 mb-0">Generate Location</label>
                    <toggle-button
                        class="changed-font mb-0"
                        v-model="form.onboardingOptions.generateLocation"
                        :color="{ checked: '#0074d9', unchecked: '#dc3545' }"
                        :labels="{ checked: 'Yes', unchecked: 'No' }"
                        :width="85"
                        :speed="200"
                    />
                </div>
                <div v-show="form.onboardingOptions.generateLocation">
                    <input-text v-model="form.onboardingOptions.location.name" field="location_name" :form="form" label="Location Name" />
                    <div class="form-group">
                        <label>Address</label>

                        <input
                            v-model="form.onboardingOptions.location.address"
                            type="text"
                            class="form-control"
                            :class="[{ 'is-invalid': form && form.errors.has('location_address') }]"
                            ref="google_address"
                        />
                        <p class="invalid-feedback" v-if="form && form.errors.has('location_address')">
                            {{ form.errors.get("location_address") }}
                        </p>
                    </div>
                    <input-text
                        v-model="form.onboardingOptions.location.googleUrl"
                        field="location_address"
                        :form="form"
                        label="Google URL(Optional)"
                    />
                    <input-text
                        v-model="form.onboardingOptions.location.googlePlaceId"
                        field="location_address"
                        :form="form"
                        label="Google Place ID(Optional)"
                    />
                    <input-text
                        v-model="form.onboardingOptions.location.latitude"
                        field="location_latitude"
                        :form="form"
                        label="Latitude"
                        hidden
                    />
                    <input-text
                        v-model="form.onboardingOptions.location.longitude"
                        field="location_longitude"
                        :form="form"
                        label="Longitude"
                        hidden
                    />
                    <input-text v-model="form.onboardingOptions.location.zoom" field="location_zoom" :form="form" label="zoom" hidden />
                    <div class="form-group d-flex align-items-center">
                        <label class="mr-3 mb-0">Generate Review Template</label>
                        <toggle-button
                            class="changed-font mb-0"
                            v-model="form.onboardingOptions.generateReview"
                            :color="{ checked: '#0074d9', unchecked: '#dc3545' }"
                            :labels="{ checked: 'Yes', unchecked: 'No' }"
                            :width="85"
                            :speed="200"
                        />
                    </div>
                    <div class="form-group d-flex align-items-center">
                        <label class="mr-3 mb-0">Generate Webchat</label>
                        <toggle-button
                            class="changed-font mb-0"
                            v-model="form.onboardingOptions.generateWebchat"
                            :color="{ checked: '#0074d9', unchecked: '#dc3545' }"
                            :labels="{ checked: 'Yes', unchecked: 'No' }"
                            :width="85"
                            :speed="200"
                        />
                    </div>
                </div>
            </div>
            <form-title>Billing</form-title>
            <div class="alert alert-warning">
                <div class="small">If you deactivate the billing, this company won't have charges. The plan will be free!</div>
            </div>
            <toggle-button
                class="changed-font"
                v-model="form.billing_enabled"
                :color="{ checked: '#0074d9', unchecked: '#dc3545' }"
                :labels="{ checked: 'Active', unchecked: 'Inactive' }"
                :width="85"
                :speed="200"
                :sync="form.billing_enabled"
            />
            <br />
            <transition-group name="fade-in-down">
                <label v-if="form.billing_enabled" key="label">Available Plans</label>
                <multiselect
                    key="multiselect"
                    v-if="form.billing_enabled"
                    :options="plans"
                    :multiple="true"
                    track-by="id"
                    label="nickname"
                    :hide-selected="true"
                    v-model="form.available_plans"
                    :close-on-select="false"
                    placeholder="Defaults to Basic and Advanced"
                />
            </transition-group>
        </div>
    </div>
</template>

<script>
import { HasForm } from "../../mixins";

export default {
    mixins: [HasForm],

    props: {
        value: { required: true, type: Form },
        systemConfig: {
            default: {
                kioskOwnerDetailsDisabled: false,
            },
        },
    },

    mounted: function () {
        this.fetchSupportedTimezones();
        this.fetchCountryCodes();
        this.fetchStates();
        this.fetchAgencies();
        this.setBusinessTypes();
        this.setIndustries();
        this.setRegistrationIdentifiers();
        this.setCompanyTypes();
        this.setStockExchanges();
    },
    computed: {
        position() {
            return { lat: this.form.onboardingOptions.location.latitude, lng: this.form.onboardingOptions.location.longitude };
        },
    },
    data: () => ({
        base_route: "api.teams",
        plans: [],
        timezones: [],
        countryCodes: [],
        states: [],
        agencies: [],
        businessTypes: [],
        industries: [],
        registrationIdentifiers: [],
        companyTypes: [],
        stockExchanges: [],
        initialGoogleSetup: true,
        autocomplete: null,
        createdListenerForAutocomplete: false,
        searchEIN: "",
        parentTeamOwnerDetailsResponse: null,
        searchingEIN: false,
    }),

    watch: {
        value() {
            this.form = this.value;
        },
    },

    created() {
        this.fetchPlans();
    },

    methods: {
        change(e) {
            this.$emit("input", this.form);
        },
        initGoogleSetup() {
            if (this.initialGoogleSetup) {
                this.initialGoogleSetup = false;
                let options = {
                    fields: ["address_components", "geometry", "icon", "name"],
                    strictBounds: false,
                };
                this.autocomplete = new google.maps.places.Autocomplete(
                    /** @type {!HTMLInputElement} */ (this.$refs.google_address),
                    options
                );
                this.createdListenerForAutocomplete = true;
                this.autocomplete.addListener("place_changed", this.updatePlace);
            }
        },
        fetchPlans() {
            return this.$http.get(this.$laroute.route("api.plans.index")).then((response) => {
                this.plans = response.data.data;
            });
        },

        enableLocationPhoneNumbers(event) {
            if (event.value) {
                this.form.location_phone_numbers_enabled = true;
            }
        },

        disableSingleContactPerLocation(event) {
            if (!event.value) {
                this.form.single_contact_per_location = false;
            }
        },

        fetchCountryCodes() {
            this.$http.get("/api/available-country-codes").then((response) => {
                this.countryCodes = response.data;
            });
        },

        fetchSupportedTimezones() {
            this.$http.get("/api/supported-timezones").then((response) => {
                this.timezones = response.data;
            });
        },

        fetchStates() {
            this.$http.get("/api/us-states").then((response) => {
                this.states = response.data;
            });
        },
        fetchAgencies() {
            this.$http.get("/api/all-agencies").then((response) => {
                this.agencies = response.data;
            });
        },

        setBusinessTypes() {
            this.businessTypes = [
                {
                    id: "Sole_Proprietorship",
                    name: "Sole Proprietorship",
                },
                {
                    id: "Partnership",
                    name: "Partnership",
                },
                {
                    id: "Limited_Liability_Corporation",
                    name: "Limited Liability Corporation",
                },
                {
                    id: "Co-operative",
                    name: "Co-operative",
                },
                {
                    id: "Non-profit Corporation",
                    name: "Non-profit Corporation",
                },
                {
                    id: "Corporation",
                    name: "Corporation",
                },
            ];
        },

        setIndustries() {
            this.industries = [
                {
                    id: "AUTOMOTIVE",
                    name: "AUTOMOTIVE",
                },
                {
                    id: "AGRICULTURE",
                    name: "AGRICULTURE",
                },
                {
                    id: "BANKING",
                    name: "BANKING",
                },
                {
                    id: "CONSUMER",
                    name: "CONSUMER",
                },
                {
                    id: "EDUCATION",
                    name: "EDUCATION",
                },
                {
                    id: "ENGINEERING",
                    name: "ENGINEERING",
                },
                {
                    id: "ENERGY",
                    name: "ENERGY",
                },
                {
                    id: "OIL_AND_GAS",
                    name: "OIL_AND_GAS",
                },
                {
                    id: "FAST_MOVING_CONSUMER_GOODS",
                    name: "FAST_MOVING_CONSUMER_GOODS",
                },
                {
                    id: "FINANCIAL",
                    name: "FINANCIAL",
                },
                {
                    id: "FINTECH",
                    name: "FINTECH",
                },
                {
                    id: "FOOD_AND_BEVERAGE",
                    name: "FOOD_AND_BEVERAGE",
                },
                {
                    id: "GOVERNMENT",
                    name: "GOVERNMENT",
                },
                {
                    id: "HEALTHCARE",
                    name: "HEALTHCARE",
                },
                {
                    id: "HOSPITALITY",
                    name: "HOSPITALITY",
                },
                {
                    id: "INSURANCE",
                    name: "INSURANCE",
                },
                {
                    id: "LEGAL",
                    name: "LEGAL",
                },
                {
                    id: "MANUFACTURING",
                    name: "MANUFACTURING",
                },
                {
                    id: "MEDIA",
                    name: "MEDIA",
                },
                {
                    id: "ONLINE",
                    name: "ONLINE",
                },
                {
                    id: "RAW_MATERIALS",
                    name: "RAW_MATERIALS",
                },
                {
                    id: "REAL_ESTATE",
                    name: "REAL_ESTATE",
                },
                {
                    id: "RELIGION",
                    name: "RELIGION",
                },
                {
                    id: "RETAIL",
                    name: "RETAIL",
                },
                {
                    id: "JEWELRY",
                    name: "JEWELRY",
                },
                {
                    id: "TECHNOLOGY",
                    name: "TECHNOLOGY",
                },
                {
                    id: "TELECOMMUNICATIONS",
                    name: "TELECOMMUNICATIONS",
                },
                {
                    id: "TRANSPORTATION",
                    name: "TRANSPORTATION",
                },
                {
                    id: "TRAVEL",
                    name: "TRAVEL",
                },
                {
                    id: "ELECTRONICS",
                    name: "ELECTRONICS",
                },
                {
                    id: "NOT_FOR_PROFIT",
                    name: "NOT_FOR_PROFIT",
                },
            ];
        },

        setRegistrationIdentifiers() {
            this.registrationIdentifiers = [
                {
                    id: "EIN",
                    name: "EIN",
                },
                {
                    id: "DUNS",
                    name: "DUNS",
                },
            ];
        },

        setCompanyTypes() {
            this.companyTypes = [
                {
                    id: "private",
                    name: "private",
                },
                {
                    id: "public",
                    name: "public",
                },
                {
                    id: "non-profit",
                    name: "non-profit",
                },
                {
                    id: "government",
                    name: "government",
                },
            ];
        },

        setStockExchanges() {
            this.stockExchanges = [
                {
                    id: "NASDAQ",
                    name: "NASDAQ",
                },
                {
                    id: "NYSE",
                    name: "NYSE",
                },
            ];
        },

        async updatePlace() {
            await this.autocomplete.getPlace();
            let place = this.autocomplete.getPlace();
            if (!place.geometry) {
                window.alert("No details available for input: '" + place.name + "'");
                return;
            }
            this.form.onboardingOptions.location.address = this.$refs.google_address.value;
            this.form.onboardingOptions.location.longitude = place.geometry.location.lng();
            this.form.onboardingOptions.location.latitude = place.geometry.location.lat();
        },

        updateParentCompany() {
            if (!this.parentTeamOwnerDetailsResponse || !this.parentTeamOwnerDetailsResponse.name) {
                return;
            }
            this.form.owner_details.parent_team.id = this.parentTeamOwnerDetailsResponse.team_id;
            this.form.owner_details.parent_team.name = this.parentTeamOwnerDetailsResponse.name;
            this.form.owner_details.business_registration_identifier = this.parentTeamOwnerDetailsResponse.business_registration_identifier;
            this.form.owner_details.business_registration_number = this.parentTeamOwnerDetailsResponse.business_registration_number;
            this.parentTeamOwnerDetailsResponse = null;
            this.searchEIN = "";
        },

        async searchParentCompanyByBusinessIdentifier() {
            if (this.searchingEIN) {
                return;
            }
            this.searchingEIN = true;
            try {
                await this.$http
                    .get("/api/team-owner-details/parent-company", {
                        params: { businessIdentifier: this.searchEIN },
                    })
                    .then((response) => {
                        this.parentTeamOwnerDetailsResponse = response.data;
                    })
                    .catch((error) => {
                        this.parentTeamOwnerDetailsResponse = {
                            error: "No company found",
                        };
                        console.error("error", error);
                    })
                    .finally(() => {
                        this.searchingEIN = false;
                    });
            } catch (error) {
                this.parentTeamOwnerDetailsResponse = {
                    error: "No company found",
                };
                this.searchingEIN = false;
            }
        },
    },
};
</script>

<style scoped>
.vue-js-switch.changed-font {
    font-size: 0.8em;
}
</style>
